import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { TeamForm } from '@/components/forms/TeamForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateTeamPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/organization/teams')
  }

  const handleCancel = () => {
    navigate('/organization/teams')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New Team</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new team to the organization
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex={1} minH={0}>
            <TeamForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
